import React, { useEffect, useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import MetaTags from "react-meta-tags";
import { FaArrowLeft, FaHome } from "react-icons/fa";
import axios from "axios";
import Navbar from "../components/Navbar";
import MobileResultPage from "../components/MobileResultPage";
import "../styles/testresultpage.css";

const TestResultPage = () => {
  const [score, setScore] = useState(0);
  const [subcats, setSubcats] = useState([]);
  const [attemptedques, setAttemptedQues] = useState([]);
  const [correctques, setCorrectQues] = useState([]);
  const [userPercentile, setUserPercentile] = useState(0);
  const [userRank, setUserRank] = useState(0);

  // NEW: active tab state ('summary' | 'review')
  const [activeTab, setActiveTab] = useState("summary");

  const navigate = useNavigate();
  const location = useLocation();

  const itemStr = localStorage.getItem("isLogin");
  const item = JSON.parse(itemStr || "{}");
  const now = new Date();

  let filteredScoreArray = [];
  let count = 0;
  let rank = 0;
  let percentile = 0;

  let catName = "";
  let quesData = [];
  let ansArray = [];
  let testType = "";
  let testId = "";
  let rankArray = [];
  let categoryName = "";

  const [isMobile,setIsMobile]=useState(window.innerWidth<=768);



useEffect(()=>{

    const resize=()=>{

        setIsMobile(window.innerWidth<=768);

    };

    window.addEventListener("resize",resize);

    return ()=>window.removeEventListener("resize",resize);

},[]);

  if (location.state) {
    console.log(location.state);
    catName = location.state.catName;
    quesData = location.state.quesData;
    ansArray = location.state.ansArray;
    testType = location.state.type;
    testId = location.state.testId;
    rankArray = location.state.rankArray;
    categoryName = location.state.quesData[0].CategoryName
    
      
  }



  const scoreData = `${score}/${quesData.length}`;
  const attemptData = `${ansArray.filter((ans) => ans !== undefined).length}/${quesData.length}`;

  // Calculate score
  const submitTest = () => {
    ansArray.forEach((ans, key) => {
      if (ansArray[key] === quesData[key].Answer) count++;
    });
    setScore(count);
    filterScore();
  };

  const getSubCategories = () => {
    const items = quesData.reduce((acc, { SubCatId, SubCatName }) => {
      if (!acc[SubCatId]) acc[SubCatId] = [];
      acc[SubCatId].push(SubCatName);
      return acc;
    }, {});
    setSubcats(Object.values(items));
  };



  const attemptedQues = () => {
    let i = 0;
    const items = ansArray.reduce((acc) => {
      if (ansArray[i] !== undefined) {
        if (!acc[quesData[i].SubCatId]) {
          acc[quesData[i].SubCatId] = [];
        }
        acc[quesData[i].SubCatId].push(quesData[i].SubCatName);
      }
      if (i < ansArray.length) i++;
      return acc;
    }, {});
    setAttemptedQues(Object.values(items));
  };

  const correctQues = () => {
    let i = 0;
    const items = ansArray.reduce((acc) => {
      if (ansArray[i] !== undefined && ansArray[i] === quesData[i].Answer) {
        if (!acc[quesData[i].SubCatId]) {
          acc[quesData[i].SubCatId] = [];
        }
        acc[quesData[i].SubCatId].push(quesData[i].SubCatName);
      }
      if (i < ansArray.length) i++;
      return acc;
    }, {});
    setCorrectQues(Object.values(items));
  };

  const filterScore = () => {
    for (let i = 0; i < rankArray.length; i++) {
      
      if (rankArray[i] < count) {
        filteredScoreArray.push(rankArray[i]);
        console.log(filteredScoreArray);
        
      }
    }
    calculatePercentile();
    calculateRank();
  };

  const calculatePercentile = () => {
     
        
    if (filteredScoreArray.length === 0 && rankArray.length === 0) {
      percentile = 100;
      setUserPercentile(percentile);
    } else {
      percentile = Math.round((filteredScoreArray.length / rankArray.length) * 100);
      setUserPercentile(percentile);
    }
  };

  const calculateRank = () => {
    rank = Math.round((100 - percentile) * (rankArray.length / 100) + 1);
    setUserRank(rank);
  };

  const submitTestData = () => {
    try {
      const json = JSON.stringify({
        testid: testId,
        userid: item?.userid,
        maxscore: quesData.length,
        score: count,
        testcat: testType,
        testname: catName,
        catname: categoryName,
        rank: rank,
        percentile: percentile,
        attempted: ansArray.filter((ans) => ans !== undefined).length,
      });
      const headers = { "Content-Type": "application/json" };
      axios.post("https://epolylearning.com/Services/polyquiz.svc/SubmitUserScore", json, {
        headers,
      });
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (!itemStr || item.expiry < now.getTime()) {
      navigate("/login");
      window.location.reload(false);
    }
    submitTest();
    getSubCategories();
    attemptedQues();
    correctQues();
    submitTestData();
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <MetaTags>
        <title>{catName} Online Quiz Test Result - PolyQuiz</title>
      </MetaTags>

     

      <div className="result-page">
        {/* TAB BAR */}
        <div className="result-tabbar" role="tablist" aria-label="Result tabs">
          <button
            role="tab"
            aria-selected={activeTab === "summary"}
            className={`tab-btn ${activeTab === "summary" ? "active" : ""}`}
            onClick={() => setActiveTab("summary")}
          >
            Results Summary
          </button>
          <button
            role="tab"
            aria-selected={activeTab === "review"}
            className={`tab-btn ${activeTab === "review" ? "active" : ""}`}
            onClick={() => setActiveTab("review")}
          >
            Review Answers
          </button>
        </div>

        {/* CONTENT */}
        {activeTab==="summary" ? (

    isMobile ? (

        <MobileResultPage

            activeTab={activeTab}

            score={score}
            scoreData={scoreData}
            userRank={userRank}
            userPercentile={userPercentile}
            attemptData={attemptData}

            quesData={quesData}
            ansArray={ansArray}

            subcats={subcats}
            attemptedques={attemptedques}
            correctques={correctques}

            catName={catName}

        />

    ) : (
          <>
            <h1 className="result-title">Exam Result - {catName.toUpperCase()} Practice Test</h1>

            {/* OVERALL PERFORMANCE */}
            <section className="result-section">
              <h2>Overall Performance Summary</h2>
              <div className="overall-stats">
                <StatCard label="Score" value={scoreData} accent />
<StatCard label="Rank" value={userRank} />
<StatCard label="Attempted" value={attemptData} />

{/* compute numeric percent locally (no logic change to how score is calculated) */}
{(() => {
  const attemptedCount = ansArray.filter((a) => a !== undefined).length;
  const accuracyPercent = attemptedCount > 0 ? Math.round((score / attemptedCount) * 100) : 0;
  return (
    <>
      <StatCard
        label="Accuracy"
        value={attemptedCount > 0 ? `${accuracyPercent} %` : "0 %"}
        percent={accuracyPercent}
      />
      <StatCard label="Percentile" value={`${userPercentile} %`} percent={userPercentile} />
    </>
  );
})()}
              </div>
            </section>

            {/* SECTIONAL PERFORMANCE */}
            <section className="result-section">
              <h2>Sectional Performance Summary</h2>
              <table className="modern-table">
                <thead>
                  <tr>
                    <th>Chapter Name</th>
                    <th>Total Questions</th>
                    <th>Attempted</th>
                    <th>Score</th>
                  </tr>
                </thead>
                <tbody>
                  {subcats.map((item, key) => (
                    <tr key={key}>
                      <td className="chapter-cell">{item[0]}</td>
                      <td>
                        <ProgressBar value={item.length} total={quesData.length} type="total" />
                      </td>
                      <td>
                        {attemptedques.map((elem, k) =>
                          item.indexOf(elem[0]) !== -1 ? (
                            <ProgressBar key={k} value={elem.length} total={item.length} type="attempt" />
                          ) : null
                        )}
                      </td>
                      <td>
                        {correctques.map((elem, k) =>
                          item.indexOf(elem[0]) !== -1 ? (
                            <ProgressBar key={k} value={elem.length} total={item.length} type="score" />
                          ) : null
                        )}
                      </td>
                    </tr>
                  ))}
                  <tr className="table-footer">
                    <td>Total</td>
                    <td>{quesData.length}</td>
                    <td>{ansArray.filter((ans) => ans !== undefined).length}</td>
                    <td>{score}</td>
                  </tr>
                </tbody>
              </table>
            </section>

            {/* QUESTION-WISE ANALYSIS */}
            <section className="result-section">
              <h2>Question Wise Analysis</h2>
              <div className="legend-holder">
                <span className="dot correct"></span> Attempted & Correct
                <span className="dot wrong"></span> Attempted & Wrong
                <span className="dot unattempted"></span> Unattempted
              </div>

              <table className="modern-table">
                <thead>
                  <tr>
                    <th>Chapter Name</th>
                    <th>Questions</th>
                  </tr>
                </thead>
                <tbody>
                  {subcats.map((item, key) => (
                    <tr key={key}>
                      <td className="chapter-cell">{item[0]}</td>
                      <td>
                        <div className="chip-list">
                          {quesData.map((elem, idx) => {
                            if (item[0] === elem.SubCatName) {
                              const isAttempted = ansArray[idx] !== undefined;
                              const isCorrect = ansArray[idx] === elem.Answer;
                              const chipClass = !isAttempted
                                ? "chip unattempted"
                                : isCorrect
                                ? "chip correct"
                                : "chip wrong";
                              return (
                                <div key={idx} className={chipClass} title={elem.Question}>
                                  {idx + 1}
                                </div>
                              );
                            }
                            return null;
                          })}
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </section>

            {/* ACTION BUTTONS */}
            <div className="action-row">
              {/* <Link
                to={`/online-quiz-test-answers/${catName.replaceAll(" ", "-")}`}
                state={{ ansArray: ansArray, catName: catName, quesData: quesData }}
                className="primary-btn"
              >
                View Solution
              </Link> */}
              {/* <Link to="/" className="secondary-btn">
                Go Back to Tests
              </Link> */}
            </div>
          </>
    )
        ) : (
          // REVIEW ANSWERS TAB
          isMobile ? (

        <SolutionTab
            quesData={quesData}
            ansArray={ansArray}
            catName={catName}
            onBackToAnalysis={() => setActiveTab("summary")}
        />

    ) : (

        <SolutionTab
            quesData={quesData}
            ansArray={ansArray}
            catName={catName}
            onBackToAnalysis={() => setActiveTab("summary")}
        />

    )

        )}
      </div>
    </>
  );
};

export default TestResultPage;

/* Sub-components */
/* Sub-components */
const StatCard = ({ label, value, accent, percent }) => {
  // percent: optional number 0..100. If provided, the ring is shown.
  const showRing = typeof percent === "number" && !isNaN(percent);

  // clamp percent between 0 and 100 to be safe
  const p = showRing ? Math.min(100, Math.max(0, Math.round(percent))) : 0;

  return (
    <div className={`stat-card ${accent ? "accent" : ""} ${showRing ? "has-ring" : ""}`}>
      <div>
        <div className="stat-label">{label}</div>
      </div>

      <div className="stat-value" aria-hidden={false}>
        {showRing ? (
          <div
            className="stat-ring"
            role="img"
            aria-label={`${label} ${p}%`}
            style={{ ["--p"]: p }}
          >
            <div className="ring-bg" />
            <div className="ring-inner" />
            <div className="ring-label">{p}<span style={{fontSize:11, opacity:0.8, marginLeft:4}}>%</span></div>
          </div>
        ) : null}

        {/* main numeric value (kept for all) */}
        <div className="stat-value-text" style={{ fontWeight: 800, fontSize: "1.45rem" }}>
          {value}
        </div>
      </div>
    </div>
  );
};


// Suggested ProgressBar (presentational only — keep in same file or replace current small component)
const ProgressBar = ({ value = 0, total = 1, type = "total" }) => {
  const percent = total > 0 ? Math.round((value / total) * 100) : 0;
  const pctStr = `${percent}%`;

  // Choose class by type: total / attempt / score
  const cls = `progress-bar ${type}`;

  return (
    <div className={cls} role="progressbar" aria-valuenow={percent} aria-valuemin="0" aria-valuemax="100">
      <div className="fill" aria-hidden>
        {/* bar-inner width set inline so CSS transition animates */}
        <div className="bar-inner" style={{ width: pctStr }} />
        {/* optional label inside track (you can remove this if you prefer number at right) */}
        {/* <div className="inner-label">{percent}%</div> */}
      </div>

      {/* number: show value (count) and optionally the total as "6 / 30" */}
      <div className="bar-value">{value}</div>
    </div>
  );
};


/* ---------- SolutionTab: uses TestSolutionPage's rendering logic (without Navbar/MetaTags) ---------- */
const SolutionTab = ({ quesData = [], ansArray = [], catName = "", onBackToAnalysis }) => {
  const navigate = useNavigate();

  if (!Array.isArray(quesData)) quesData = [];
  if (!Array.isArray(ansArray)) ansArray = [];

  return (
    <main className="ts-root ts-root-inline">
      <header className="ts-header">
        <h1 className="ts-title">{catName.toUpperCase() + " PRACTICE TEST"} – Answer Key and Explanations</h1>
        <p className="ts-subtitle">Review your choices and the correct answers.</p>
      </header>

      <section className="ts-section">
        {quesData.map((q, idx) => {
          const selected = ansArray[idx];
          const isCorrect = (opt) => opt === q.Answer;

          return (
            <article key={q.QuestionId || idx} className="sol-card">
              <div className="sol-head">
                <div className="sol-qno">Que. {idx + 1}</div>
                <div className="sol-qtext">{q.Question}</div>
              </div>

              {q.Image1 && (
                <div className="sol-image">
                  <img
                    src={`https://epolylearning.com/QuestionImages/${q.QuestionId}-1.png`}
                    alt=""
                  />
                </div>
              )}
              {q.Image2 && (
                <div className="sol-image">
                  <img
                    src={`https://epolylearning.com/QuestionImages/${q.QuestionId}-2.png`}
                    alt=""
                  />
                </div>
              )}

              <div className="sol-options">
                <OptionRow
                  id={`q${idx}-a`}
                  text={q.Option1}
                  checked={selected === q.Option1}
                  correct={isCorrect(q.Option1)}
                />
                <OptionRow
                  id={`q${idx}-b`}
                  text={q.Option2}
                  checked={selected === q.Option2}
                  correct={isCorrect(q.Option2)}
                />
                <OptionRow
                  id={`q${idx}-c`}
                  text={q.Option3}
                  checked={selected === q.Option3}
                  correct={isCorrect(q.Option3)}
                />
                <OptionRow
                  id={`q${idx}-d`}
                  text={q.Option4}
                  checked={selected === q.Option4}
                  correct={isCorrect(q.Option4)}
                />
                {q.Option5 && (
                <OptionRow
                  id={`q${idx}-e`}
                  text={q.Option5}
                  checked={selected === q.Option5}
                  correct={isCorrect(q.Option5)}
                  
                />
        )}
              </div>
               <div className="sol-qexplanation">{q.Explanation}</div>
            </article>
          );
        })}

        {quesData.length === 0 && (
          <div className="ts-empty">
            No solution data available.{" "}
            <button className="linklike" onClick={() => navigate(-1)}>
              Go back
            </button>
            .
          </div>
        )}
      </section>

   <footer className="ts-actions">

   <button
    className="ghost-btn"
    onClick={onBackToAnalysis}
>
    <FaArrowLeft />
    Back to Analysis
</button>

<Link to="/" className="primary-btn">
    <FaHome />
    Homepage
</Link>

</footer>
    </main>
  );
};




/* ---------- OptionRow (copied from TestSolutionPage) ---------- */
function OptionRow({ id, text, checked, correct }) {
  return (
    <label className={`sol-row ${correct ? "correct" : ""}`}>
      <input className="sol-radio" type="radio" id={id} checked={!!checked} readOnly disabled />
      <span className="sol-text">{text}</span>
      {correct && (
        <span className="sol-check" aria-label="Correct answer" title="Correct answer">
          <svg viewBox="0 0 24 24" width="16" height="16" role="img" aria-hidden="true">
            <circle cx="12" cy="12" r="11" fill="none" stroke="currentColor" strokeWidth="2" />
            <path
              d="M7 12l3 3 7-7"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </span>
      )}
    </label>
  );
}


